export enum GlobalActionTypes {
  SET_LEAD_FORM = 'SET_LEAD_FORM',
  SET_QUESTION_DATA = 'SET_QUESTION_DATA',
}
